import { render, staticRenderFns } from "./PaymentType.vue?vue&type=template&id=5155f603&"
import script from "./PaymentType.vue?vue&type=script&lang=js&"
export * from "./PaymentType.vue?vue&type=script&lang=js&"
import style0 from "./PaymentType.vue?vue&type=style&index=0&id=5155f603&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports